// extracted by mini-css-extract-plugin
module.exports = {"featureImage":"FeatureImage_featureImage__25F5R","greeting":"FeatureImage_greeting__3dTpd","featureShoe":"FeatureImage_featureShoe__33745"};